module.exports = __webpack_public_path__ + "2f79b8bbf439fe5338bb3a85be315ced.pdf";